module.exports = __webpack_public_path__ + "fae7ab8c0d93947b7a558d08d7035570.png";